namespace GeniuzPOS.Lookups {
    export interface VwDashboardPageRow {
        ShopId?: string;
        DayCount?: number;
        DaynNetSale?: number;
        MonthCount?: number;
        MonthNetSale?: number;
        LowStock?: number;
        SlowMoveAll?: number;
    }

    export namespace VwDashboardPageRow {
        export const idProperty = 'ShopId';
        export const nameProperty = 'ShopId';
        export const localTextPrefix = 'Lookups.VwDashboardPage';
        export const lookupKey = 'VwDashboardPage';

        export function getLookup(): Q.Lookup<VwDashboardPageRow> {
            return Q.getLookup<VwDashboardPageRow>('VwDashboardPage');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            ShopId = "ShopId",
            DayCount = "DayCount",
            DaynNetSale = "DaynNetSale",
            MonthCount = "MonthCount",
            MonthNetSale = "MonthNetSale",
            LowStock = "LowStock",
            SlowMoveAll = "SlowMoveAll"
        }
    }
}
